export const seconds = str => {
  const [min, sec] = str.split(':')
  return (+min) * 60 + (+sec)
}

export const intervalStart = str => {
  const start = str.split('-')[0]
  return seconds(start)
}

export const intervalEnd = str => {
  const end = str.split('-')[1]
  return seconds(end)
}

export const fmtSeconds = seconds => {
  const min = Math.floor(seconds/60)
  const sec = Math.floor(seconds % 60)
  const padding = sec < 10 ? '0' : ''
  return min + ':' + padding + sec
}

export const bridgeCall = (method, params) => {
  if (window.ReactNativeWebView) {
    const msg = JSON.stringify([method, params])
    window.ReactNativeWebView.postMessage(msg)
  }
}

export const playSound = (soundName) => {
  bridgeCall('playSound', {soundName})
}
